import { useAppScopeStore } from '@frontend/scope';

export const useIsACI = () => {
  const { selectedOrgId } = useAppScopeStore();

  // We need to hide the production value for ACI locations,
  // The quickest way we have right now is to verify it against the orgId
  return selectedOrgId === '247a62fd-d24d-442c-bfa7-e682243832bd';
};
